(() => {
  const banner = document.getElementById('BirdConsentBanner');
  const settingsButton = document.getElementById('BirdConsentSettings');

  if (!banner || !settingsButton || !window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return;

  const choices = banner.querySelector('#BirdConsentChoices');
  const panel = banner.closest('details');
  const manageButton = banner.querySelector('[data-consent-action="manage"]');
  const saveButton = banner.querySelector('[data-consent-action="save"]');
  const purposeInputs = [...banner.querySelectorAll('[data-consent-purpose]')];

  const privacyApi = () => window.Shopify.customerPrivacy;

  const syncChoices = () => {
    if (typeof privacyApi().currentVisitorConsent !== 'function') return;
    const current = privacyApi().currentVisitorConsent();
    purposeInputs.forEach((input) => {
      input.checked = current[input.dataset.consentPurpose] === 'yes';
    });
  };

  const openBanner = (force = false) => {
    const shouldShow = typeof privacyApi().shouldShowBanner === 'function' && privacyApi().shouldShowBanner();
    if (force || shouldShow) {
      panel.open = true;
      syncChoices();
      banner.querySelector('[data-consent-action="accept"]').focus();
    }
  };

  const closeBanner = () => {
    panel.open = false;
    choices.hidden = true;
    saveButton.hidden = true;
    manageButton.hidden = false;
    manageButton.setAttribute('aria-expanded', 'false');
    settingsButton.focus();
  };

  const recordConsent = (consent) => {
    privacyApi().setTrackingConsent(consent, closeBanner);
  };

  window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
    if (error || !privacyApi()) return;

    banner.addEventListener('click', (event) => {
      const action = event.target.closest('[data-consent-action]')?.dataset.consentAction;
      if (!action) return;

      if (action === 'accept') {
        recordConsent({ preferences: true, analytics: true, marketing: true });
      } else if (action === 'reject') {
        recordConsent({ preferences: false, analytics: false, marketing: false });
      } else if (action === 'manage') {
        choices.hidden = false;
        saveButton.hidden = false;
        manageButton.hidden = true;
        manageButton.setAttribute('aria-expanded', 'true');
        purposeInputs[0]?.focus();
      } else if (action === 'save') {
        const selected = Object.fromEntries(
          purposeInputs.map((input) => [input.dataset.consentPurpose, input.checked])
        );
        recordConsent(selected);
      }
    });

    document.addEventListener('visitorConsentCollected', syncChoices);
    openBanner(false);
  });
})();
